import React, { Fragment } from 'react';

// Icons
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

// Imgs
import zoomErrorPic from '../../util/imgs/zoom_error.webp'
  
const Shows_When_Sharing = ({
    isMobile
  }) =>  {
    return (
        <Fragment>
              
            {/* Heading */}
            <div style={{paddingBottom: '2rem', marginBottom: '2rem', borderBottom: '1px solid rgb(39,39,42)'}}>
                <h1 style={{fontWeight: 'bold', fontSize: '1.5rem', margin: 0}}>
                    Shows When Sharing Screen
                </h1>
                <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', marginTop: '.5rem'}}>
                    Quick fixes for visibility issues during screen sharing.
                </p>
            </div>
            {/* Main content */}
            <div>
                {/* Box Section */}
                <div style={{marginTop: '2rem', padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                    <h2 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                        The app works with current Zoom versions.
                    </h2>
                    <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', marginTop: '1rem'}}>
                        All you have to do is enable Advanced capture with window filtering.
                    </p>
                    <div style={{width: '100%', marginTop: '1rem'}}>
                        <img alt="Zoom Advanced Capture Settings" loading="lazy" decoding="async" src={zoomErrorPic} style={{width: '100%', height: 'auto'}} />
                    </div>
                </div>
            </div>
            {/* Alert Box */}
            <div style={{marginTop: '2rem', padding: '1.5rem', background: 'rgb(239,68,68,.1)', border: '1px solid rgb(239,68,68,.2)', borderRadius: '.75rem', display: 'flex', gap: '.75rem'}}>
                {/* Icon */}
                <div style={{marginTop: '.25rem', color: 'rgb(248,113,113)'}}>
                    <ErrorOutlineOutlinedIcon />
                </div>
                {/* Body section */}
                <div>
                    <h3 style={{color: 'rgb(248,113,113)', fontWeight: 500, fontSize: '.875rem', margin: 0}}>
                        MacOS Screen Sharing Error
                    </h3>
                    <p style={{marginTop: '.5rem', color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem'}}>
                        Due to an unresolved bug, some WebRTC-based screen-sharing software may be able to see Interview Cheater on MacOS while sharing your full screen. To see if you're affected, download the application without subscribing and try to screen-share. If it shows, then you're affected. Please be careful to note this as we do not offer refunds.
                    </p>
                </div>
            </div>
        </Fragment>
    );
  }
  
  export default Shows_When_Sharing;
  